export type PlanningItem = server.dto.ShowForPlanningMap | server.dto.VenueSmall | server.dto.Airport;

export const getLocation = (item: PlanningItem): server.dto.Geo => {
  if(isVenueItem(item)) {
    return item.location
  }

  return item.point;
}

export const isShowItem = (item: PlanningItem): item is server.dto.ShowForPlanningMap => {
  return (item as server.dto.ShowForPlanningMap).showId !== undefined;
}

export const isVenueItem = (item: PlanningItem): item is server.dto.VenueSmall => {
  return (item as server.dto.VenueSmall).venueId !== undefined;
}

export const isAirportItem = (item: PlanningItem): item is server.dto.Airport => {
  return (item as server.dto.Airport).airportId !== undefined;
}

export const allFilterLayers = ["show", "venue", "airport"] as const;
export type FilterLayerType = typeof allFilterLayers[number];

export const showListUniqueKey = "planningMap_showList";

export const getListUniqueKey = (layer: FilterLayerType) => `planningMap_${layer}List`;

export const groupPlanningItemsByLocation = (items: PlanningItem[]): Record<string, Array<PlanningItem>> => {
  return items.reduce((acc, item) => {
    const location = getLocation(item);
    const key = `${location.lat},${location.lng}`;
    acc[key] = (acc[key] || []).concat(item);
    return acc;
  }, {});
}

export const sortPlanningItemWithFilteredInFront = <T extends PlanningItem>(items: T[], selectedPoint: server.dto.Geo): T[] => {
  return [...items].sort((a, b) => {
    const isSelectedA = planningItemIsOnLocation(a, selectedPoint);
    const isSelectedB = planningItemIsOnLocation(b, selectedPoint);

    if (isSelectedA && !isSelectedB) {
      return -1;
    }

    if (!isSelectedA && isSelectedB) {
      return 1;
    }

    return 0;
  });
}

export const planningItemIsOnLocation = (item: PlanningItem, location: server.dto.Geo): boolean => {
  const itemLocation = getLocation(item);
  return itemLocation.lat === location.lat && itemLocation.lng === location.lng;
}